// extracted by mini-css-extract-plugin
module.exports = {"section":"testimonials_section__6YGgp","container":"testimonials_container___ygYl"};